<template>
  <div>
    <DeleteModal
      :is-delete-modal-active.sync="isDeleteModalActive"
      :items="deleteItem"
      @confirm-delete="confirmDelete($event)" />
    <CompanyDepartmentAdd
      ref="companyDepartmentAdd"
      :is-sidebar-active.sync="isSidebarActive"
      @add-company-department="addCompanyDepartment" />
    <CompanyDepartmentDetail
      :is-sidebar-active.sync="isSidebarDetailActive"
      :initial-company-department="initialCompanyDepartment"
      :selected-item.sync="selectedItem"
      @update-company-department="updateCompanyDepartment($event)"
      @delete-item="openDeleteModal($event)" />
    <CompanyDepartmentFilter
      :search.sync="filter.searchCodeAndName"
      :status-filter.sync="filter.status"
      @fetch-filter="fetchFilter()" />
    <b-card class="mt-2">
      <TableTop
        v-model="pagination.limit"
        label="Add Company Department"
        @active-sidebar="activeSidebar()"
        @change="fetchFilter()" />
      <b-table
        :items="items"
        :fields="fields"
        striped
        hover
        responsive
        @sort-changed="sortFilter($event)"
        @row-clicked="rowClick($event)">
        <template #cell(status)="data">
          <b-badge :variant="$statusValue(data.value)">
            {{ data.value | formatStatusData }}
          </b-badge>
        </template>
        <template #cell(code)="data">
          <span class="font-weight-semibold text-primary">#{{ data.value }}</span>
        </template>
        <template #cell(name)="data">
          <span class="font-weight-semibold">{{ data.value }}</span>
        </template>
      </b-table>
      <b-row>
        <b-col
          cols="12"
          sm="12"
          class="d-flex align-items-center justify-content-center justify-content-sm-end">
          <b-pagination
            v-model="pagination.page"
            :total-rows="pagination.totalDocs"
            :per-page="pagination.limit"
            first-number
            last-number
            class="mb-1 mt-2 mr-1"
            prev-class="prev-item"
            next-class="next-item"
            @change="showCurrentPage($event)">
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18" />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import CompanyDepartmentAdd from '@/components/Customers/CompanyDepartment/CompanyDepartmentAdd.vue'
import CompanyDepartmentDetail from '@/components/Customers/CompanyDepartment/CompanyDepartmentDetail.vue'
import CompanyDepartmentFilter from '@/components/Customers/CompanyDepartment/CompanyDepartmentFilter.vue'
import CompanyDepartmentProvider from '@/resources/CompanyDepartmentProvider'
import DeleteModal from '@/components/DeleteModal.vue'
import TableTop from '@/components/TableTop.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const CompanyDepartmentService = new CompanyDepartmentProvider()

export default {
  components: {
    CompanyDepartmentAdd,
    CompanyDepartmentDetail,
    CompanyDepartmentFilter,
    DeleteModal,
    TableTop
  },
  data () {
    return {
      isSidebarActive: false,
      isSidebarDetailActive: false,
      isDeleteModalActive: false,
      filter: {
        searchCodeAndName: '',
        status: ''
      },
      pagination: {
        page: 1,
        limit: 10,
        totalDocs: 10
      },
      fields: [
        { key: 'code', label: 'Code', sortable: true },
        { key: 'name', label: 'Name', sortable: true },
        { key: 'remark', label: 'Remark' },
        { key: 'status', label: 'Status' }
      ],
      items: [],
      initialCompanyDepartment: {},
      selectedItem: {},
      deleteItem: {}
    }
  },
  created () {
    this.getCompanyDepartment()
  },
  methods: {
    async getCompanyDepartment () {
      try {
        const data = await CompanyDepartmentService.paginate(this.pagination.page, this.pagination.limit, this.filter)
        this.setPagination(data.page, data.totalDocs)
        this.items = [...data.data]
      } catch (err) {
        console.error(err)
      }
    },
    async addCompanyDepartment (val) {
      try {
        await CompanyDepartmentService.createGroup(val)
        await this.getCompanyDepartment()
        this.resetFormAndToggleSideBar(this.$refs.companyDepartmentAdd)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Add Record Successfully',
            icon: 'EditIcon',
            variant: 'success',
            text: '👋 Company Department has been added'
          }
        })
      } catch (err) {
        console.error(err)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Add Fail',
            icon: 'EditIcon',
            variant: 'danger',
            text: '😞 Company Department has been Failed'
          }
        })
      }
    },
    async updateCompanyDepartment (val) {
      try {
        const payload = { ...val }
        delete payload.id
        const { data } = await CompanyDepartmentService.updateGroup(val.id, payload)
        await this.getCompanyDepartment()
        this.setDataInitialAndSelectItem(data)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Updated Successfully',
            icon: 'EditIcon',
            variant: 'success',
            text: '👋 Company Department has been updated'
          }
        })
      } catch (err) {
        console.log(err)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Update Fail',
            icon: 'EditIcon',
            variant: 'danger',
            text: '😞 Company Department has been Failed'
          }
        })
      }
    },
    async confirmDelete (val) {
      try {
        this.isSidebarDetailActive = false
        await CompanyDepartmentService.deleteGroup(val.ID)
        await this.getCompanyDepartment()
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Deleted Successfully',
            icon: 'EditIcon',
            variant: 'success',
            text: '👋 Company Department Type has been deleted'
          }
        })
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Deleted Fail',
            icon: 'EditIcon',
            variant: 'danger',
            text: `😞 Company Department has been Failed ${error}`
          }
        })
      }
    },
    activeSidebar () {
      this.isSidebarActive = true
    },
    rowClick (val) {
      this.setDataInitialAndSelectItem(val)
      this.isSidebarDetailActive = true
    },
    openDeleteModal (val) {
      this.deleteItem = { ...val }
      this.isDeleteModalActive = true
    },
    setDataInitialAndSelectItem (val) {
      this.selectedItem = { ...val }
      this.initialCompanyDepartment = { ...val }
    },
    resetFormAndToggleSideBar (ref) {
      this.isSidebarActive = !this.isSidebarActive
      if (ref && ref.resetForm()) ref.resetForm()
    },
    fetchFilter () {
      this.setPagination(1)
      this.getCompanyDepartment()
    },
    showCurrentPage (page) {
      this.setPagination(page)
      this.getCompanyDepartment()
    },
    setPagination (page, totalDocs) {
      this.pagination.page = page || this.pagination.page
      this.pagination.totalDocs = totalDocs || this.pagination.totalDocs
    }
  }
}
</script>

<style lang="scss" scoped>
.card-body {
  padding: 0;
}
</style>
